import styled from 'styled-components';
import GroupButtons from './GroupButtons';
const ControlButtons = () => {
  return (
    <Wrapper>
      <GroupButtons />
    </Wrapper>
  );
};

export default ControlButtons;

const Wrapper = styled.section`
`;
